import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom';
import axios from 'axios';
import _ from 'lodash';
// import fetch from 'node-fetch';
//import fs from 'fs';
import qs from 'qs';
import filedownload from 'react-file-download';

import 'react-day-picker/lib/style.css';

import Raporlar from './pages/rapor/index.js';
import Kurumlar from './components/kurumList.js';
import Istatistik from './pages/istatistik/index.js';
import Login from './pages/login/index.js';

import S from './styles/style'
import Logo from './img/sulogo.png'
import Nav from './components/nav/index.js';
import SearchImg from './img/musica-searcher.png'

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import "antd/dist/antd.css";
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authontication: false,
      permission: false,
      panel: true,
      girisMetni: "Raporlarınızı görmek için lütfen yukarıdaki raporlar linkine tıklayınız...",
      eren: [],
      kurumarray: [],
      listeleme: [112, 15, 13],
      deneme: [],
      numbers: [1, 2, 3, 4, 5],
      sayilar: [1, 2, 3, 4, 5],
      veri: [],
      raporlar: null,
      arananDosya: "",
      durum: false,
      silme: "dendeme",
      webusername: "",
      webpassword: "",
      apiUrl: "http://reportapi.bestbilgisayar.info/",
      logindurum: "",
      kurumInfo: "",
      open: false
    }
    this.handleChangeUser = this.handleChangeUser.bind(this);
    this.handleChangePass = this.handleChangePass.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.kurumSubmit = this.kurumSubmit.bind(this);
    this.numuneGidaSubmit = this.numuneGidaSubmit.bind(this);
    this.numuneSuSubmit = this.numuneSuSubmit.bind(this);
    this.numuneHavuzSuSubmit = this.numuneHavuzSuSubmit.bind(this);
    this.numuneHavuzSuyuSubmit = this.numuneHavuzSuyuSubmit.bind(this);
    this.numuneDenizSuyuSubmit = this.numuneDenizSuyuSubmit.bind(this);
    this.numuneMantarSubmit = this.numuneMantarSubmit.bind(this);
    this.numuneKimyasalSubmit = this.numuneKimyasalSubmit.bind(this);
    this.numuneLegionellaSubmit = this.numuneLegionellaSubmit.bind(this);
    this.numuneDenizSubmit = this.numuneDenizSubmit.bind(this);
    this.numuneOrtamSubmit = this.numuneOrtamSubmit.bind(this);
    this.numuneSwabSubmit = this.numuneSwabSubmit.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.aramaCubugu = this.aramaCubugu.bind(this);
    this.aramaKurumCubugu = this.aramaKurumCubugu.bind(this);
    this.webuserCubugu = this.webuserCubugu.bind(this);
    this.webpassCubugu = this.webpassCubugu.bind(this);
    this.silme = this.silme.bind(this);
    this.indir = this.indir.bind(this);
    this.edit = this.edit.bind(this);
    this.kullanici = this.kullanici.bind(this);
    this._handleKeyPress = this._handleKeyPress.bind(this);
    this._handleKeyPressKurum = this._handleKeyPressKurum.bind(this);
    this.cikis = this.cikis.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
  }
  handleClose() {
    // setOpen(false);
    this.setState({ open: false });
  };
  handleToggle() {
    this.setState({ open: !this.state.open });
  };
  webuserCubugu(event) {
    this.setState({ webusername: event.target.value });
  }
  cikis(event) {
    this.setState({ authontication: false, permission: false, panel: true, logindurum: "" });
  }
  webpassCubugu(event) {
    this.setState({ webpassword: event.target.value });
  }
  handleChangeUser(event) {
    this.setState({ username: event.target.value, logindurum: '' });
  }
  handleChangePass(event) {
    this.setState({ password: event.target.value, logindurum: '' });
  }
  handleLogin(event) {
    var uservariable = this.state.username;
    var passvariable = this.state.password;
    var url = this.state.apiUrl + 'kurum/giris/';
    var data = qs.stringify({
      webusername: uservariable,
      webpassword: passvariable
    });
    var config = {
      async: false,
      headers: {
        'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ=',
        'Content-type': 'application/x-www-form-urlencoded'
      }
    };
    var self = this;
    axios.post(url, data, config).then(function (response) {
      if (response.data.Sonuc[0].Aciklama != null) {
        var find = ' ';
        var a = response.data.Sonuc[0].Aciklama;
        var re = new RegExp(find, 'g');
        var temp = a.replace(re, '_');
        self.setState({ kurumVar: temp });
      } else {
        self.setState({ logindurum: "Kullanıcı adı veya şifre doğru değil,tekrar deneyiniz..." })
      }
      var kuruminfo = response.data.Sonuc;
      var auth = response.data.Oturum;
      var perm = response.data.Yetki;
      var pan = response.data.Panel;
      self.setState({ authontication: auth, permission: perm, panel: pan, kurumInfo: kuruminfo });
    });
  }
  handleSubmit(event) {
    this.setState({ durum: false });
    this.setState({ eren: null });
    var url = this.state.apiUrl + 'numunePdf/getir/' + this.state.arananDosya;
    fetch(url, {
      method: "GET",
      async: false,
      crossDomain: true,
      xhrFields: {
        withCredentials: false
      },
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ='
      },
    }).then((response) => {
      console.log(response)
      var contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        return response.json().then((re) => {
          if (re.Sonuc[0].DosyaAd) {
            var rapArr = _.sortBy(re.Sonuc, 'Tarih', function (n) {
              return Math.sin(n);
            });
            this.setState({ eren: rapArr.reverse() });
            this.setState({ durum: true });
          } else { this.setState({ durum: false }); }
        }).catch(err => {

          this.setState({ durum: false });
        })
      }
      else { }
    })
  }
  kurumSubmit(event) {
    var config = {
      async: false,
      headers: {
        'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ=',
        'Content-type': 'application/x-www-form-urlencoded'
      }
    };

    var url = this.state.apiUrl + 'kurum/getir/' + this.state.aranankurum;

    var self = this;
    axios.get(url, config).then(function (response) {

      if (response.data.Sonuc[0].Aciklama) {
        var newArr = _.sortBy(response.data.Sonuc, 'Kod', function (n) {
          return Math.sin(n);
        });


        self.setState({ kurumarray: newArr.reverse() });
        self.setState({ durum: true });
      } else {
        self.setState({ durum: false });
      }

    });
  }
  numuneGidaSubmit(event) {
    this.setState({ durum: false });
    this.setState({ eren: null });
    this.setState({ listebilgi: '' });
    var parameters = this.state.kurumVar + '/1';
    var url = this.state.apiUrl + 'numunePdf/kurumgetir/' + parameters;
    fetch(url, {
      method: "GET",
      async: false,
      crossDomain: true,
      xhrFields: {
        withCredentials: false
      },
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ='
      },
    })
      .then((response) => {

        var contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((re) => {
            //this.setState({ eren: re.Sonuc});
            if (re.Sonuc[0].DosyaAd) {
              var newArr = _.sortBy(re.Sonuc, 'Tarih', function (n) {
                return Math.sin(n);
              });

              this.setState({ eren: newArr.reverse() });
              this.setState({ durum: true });
              //var dosyaPath = re.Sonuc[0].DosyaAd;
              //var dosyaRealPath = dosyaPath.replace('ftp://khufu.bestbilgisayar.info//','C:/RaporlarEren/SUDUNYASI/');
              //var dosyaYol = dosyaRealPath.replace('ftp://93.89.72.167//','C:/RaporlarEren/SUDUNYASI/');

            } else {
              this.setState({ durum: false });
              this.setState({ listebilgi: 'Sonuç bulunamadı...' });
            }


          }).catch(err => {

            this.setState({ durum: false });
          })
        } else {// var den= json.Sonuc[0].DosyaAd;

        }
      })
  }
  numuneSuSubmit(event) {
    this.setState({ durum: false });
    this.setState({ eren: null });
    this.setState({ listebilgi: '' });
    var parameters = this.state.kurumVar + '/6';
    var url = this.state.apiUrl + 'numunePdf/kurumgetir/' + parameters;
    fetch(url, {
      method: "GET",
      async: false,
      crossDomain: true,
      xhrFields: {
        withCredentials: false
      },
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ='
      },
    })
      .then((response) => {

        var contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((re) => {
            //this.setState({ eren: re.Sonuc});
            if (re.Sonuc[0].DosyaAd) {
              var newArr = _.sortBy(re.Sonuc, 'Tarih', function (n) {
                return Math.sin(n);
              });

              this.setState({ eren: newArr.reverse() });
              this.setState({ durum: true });
              //var dosyaPath = re.Sonuc[0].DosyaAd;
              //var dosyaRealPath = dosyaPath.replace('ftp://khufu.bestbilgisayar.info//','C:/RaporlarEren/SUDUNYASI/');
              //var dosyaYol = dosyaRealPath.replace('ftp://93.89.72.167//','C:/RaporlarEren/SUDUNYASI/');

            } else {
              this.setState({ durum: false });
              this.setState({ listebilgi: 'Sonuç bulunamadı...' });
            }


          }).catch(err => {

            this.setState({ durum: false });
          })
        } else {// var den= json.Sonuc[0].DosyaAd;

        }
      })
  }
  numuneHavuzSuSubmit(event) {
    this.setState({ durum: false });
    this.setState({ eren: null });
    this.setState({ listebilgi: '' });
    var parameters = this.state.kurumVar + '/3';
    var url = this.state.apiUrl + 'numunePdf/kurumgetir/' + parameters;
    fetch(url, {
      method: "GET",
      async: false,
      crossDomain: true,
      xhrFields: {
        withCredentials: false
      },
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ='
      },
    })
      .then((response) => {

        var contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((re) => {
            //this.setState({ eren: re.Sonuc});
            if (re.Sonuc[0].DosyaAd == null) {
              this.setState({ listebilgi: 'Sonuç bulunamadı' });
            }
            if (re.Sonuc[0].DosyaAd) {
              var newArr = _.sortBy(re.Sonuc, 'Tarih', function (n) {
                return Math.sin(n);
              });


              this.setState({ eren: newArr.reverse() });
              this.setState({ durum: true });
              //var dosyaPath = re.Sonuc[0].DosyaAd;
              //var dosyaRealPath = dosyaPath.replace('ftp://khufu.bestbilgisayar.info//','C:/RaporlarEren/SUDUNYASI/');
              //var dosyaYol = dosyaRealPath.replace('ftp://93.89.72.167//','C:/RaporlarEren/SUDUNYASI/');

            } else {
              this.setState({ durum: false });
              this.setState({ listebilgi: 'Sonuç bulunamadı...' });
            }


          }).catch(err => {

            this.setState({ durum: false });
          })
        } else {// var den= json.Sonuc[0].DosyaAd;

        }
      })
  }
  numuneDenizSuyuSubmit(event) {
    this.setState({ durum: false });
    this.setState({ eren: null });
    this.setState({ listebilgi: '' });
    var parameters = this.state.kurumVar + '/10';
    var url = this.state.apiUrl + 'numunePdf/kurumgetir/' + parameters;
    fetch(url, {
      method: "GET",
      async: false,
      crossDomain: true,
      xhrFields: {
        withCredentials: false
      },
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ='
      },
    })
      .then((response) => {

        var contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((re) => {
            //this.setState({ eren: re.Sonuc});
            if (re.Sonuc[0].DosyaAd == null) {
              this.setState({ listebilgi: 'Sonuç bulunamadı' });
            }
            if (re.Sonuc[0].DosyaAd) {
              var newArr = _.sortBy(re.Sonuc, 'Tarih', function (n) {
                return Math.sin(n);
              });


              this.setState({ eren: newArr.reverse() });
              this.setState({ durum: true });

              //var dosyaPath = re.Sonuc[0].DosyaAd;
              //var dosyaRealPath = dosyaPath.replace('ftp://khufu.bestbilgisayar.info//','C:/RaporlarEren/SUDUNYASI/');
              //var dosyaYol = dosyaRealPath.replace('ftp://93.89.72.167//','C:/RaporlarEren/SUDUNYASI/');

            } else {
              this.setState({ durum: false });
              this.setState({ listebilgi: 'Sonuç bulunamadı...' });
            }


          }).catch(err => {

            this.setState({ durum: false });
          })
        } else {// var den= json.Sonuc[0].DosyaAd;

        }
      })
  }
  numuneMantarSubmit(event) {
    this.setState({ durum: false });
    this.setState({ eren: null });
    this.setState({ listebilgi: '' });
    var parameters = this.state.kurumVar + '/9';
    var url = this.state.apiUrl + 'numunePdf/kurumgetir/' + parameters;
    fetch(url, {
      method: "GET",
      async: false,
      crossDomain: true,
      xhrFields: {
        withCredentials: false
      },
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ='
      },
    })
      .then((response) => {

        var contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((re) => {
            //this.setState({ eren: re.Sonuc});
            if (re.Sonuc[0].DosyaAd == null) {
              this.setState({ listebilgi: 'Sonuç bulunamadı' });
            }
            if (re.Sonuc[0].DosyaAd) {
              var newArr = _.sortBy(re.Sonuc, 'Tarih', function (n) {
                return Math.sin(n);
              });


              this.setState({ eren: newArr.reverse() });
              this.setState({ durum: true });

              //var dosyaPath = re.Sonuc[0].DosyaAd;
              //var dosyaRealPath = dosyaPath.replace('ftp://khufu.bestbilgisayar.info//','C:/RaporlarEren/SUDUNYASI/');
              //var dosyaYol = dosyaRealPath.replace('ftp://93.89.72.167//','C:/RaporlarEren/SUDUNYASI/');

            } else {
              this.setState({ durum: false });
              this.setState({ listebilgi: 'Sonuç bulunamadı...' });
            }


          }).catch(err => {

            this.setState({ durum: false });
          })
        } else {// var den= json.Sonuc[0].DosyaAd;

        }
      })
  }
  numuneHavuzSuyuSubmit(event) {
    this.setState({ durum: false });
    this.setState({ eren: null });
    this.setState({ listebilgi: '' });
    var parameters = this.state.kurumVar + '/2';
    var url = this.state.apiUrl + 'numunePdf/kurumgetir/' + parameters;
    fetch(url, {
      method: "GET",
      async: false,
      crossDomain: true,
      xhrFields: {
        withCredentials: false
      },
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ='
      },
    })
      .then((response) => {

        var contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((re) => {
            //this.setState({ eren: re.Sonuc});
            if (re.Sonuc[0].DosyaAd == null) {
              this.setState({ listebilgi: 'Sonuç bulunamadı' });
            }
            if (re.Sonuc[0].DosyaAd) {
              var newArr = _.sortBy(re.Sonuc, 'Tarih', function (n) {
                return Math.sin(n);
              });


              this.setState({ eren: newArr.reverse() });
              this.setState({ durum: true });

              //var dosyaPath = re.Sonuc[0].DosyaAd;
              //var dosyaRealPath = dosyaPath.replace('ftp://khufu.bestbilgisayar.info//','C:/RaporlarEren/SUDUNYASI/');
              //var dosyaYol = dosyaRealPath.replace('ftp://93.89.72.167//','C:/RaporlarEren/SUDUNYASI/');

            } else {
              this.setState({ durum: false });
              this.setState({ listebilgi: 'Sonuç bulunamadı...' });
            }


          }).catch(err => {

            this.setState({ durum: false });
          })
        } else {// var den= json.Sonuc[0].DosyaAd;

        }
      })
  }
  numuneKimyasalSubmit(event) {
    this.setState({ durum: false });
    this.setState({ eren: null });
    this.setState({ listebilgi: '' });
    var parameters = this.state.kurumVar + '/4';
    var url = this.state.apiUrl + 'numunePdf/kurumgetir/' + parameters;
    fetch(url, {
      method: "GET",
      async: false,
      crossDomain: true,
      xhrFields: {
        withCredentials: false
      },
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ='
      },
    })
      .then((response) => {

        var contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((re) => {
            //this.setState({ eren: re.Sonuc});
            if (re.Sonuc[0].DosyaAd) {
              var newArr = _.sortBy(re.Sonuc, 'Tarih', function (n) {
                return Math.sin(n);
              });


              this.setState({ eren: newArr.reverse() });
              this.setState({ durum: true });
              //var dosyaPath = re.Sonuc[0].DosyaAd;
              //var dosyaRealPath = dosyaPath.replace('ftp://khufu.bestbilgisayar.info//','C:/RaporlarEren/SUDUNYASI/');
              //var dosyaYol = dosyaRealPath.replace('ftp://93.89.72.167//','C:/RaporlarEren/SUDUNYASI/');

            } else {
              this.setState({ durum: false });
              this.setState({ listebilgi: 'Sonuç bulunamadı...' });
            }


          }).catch(err => {

            this.setState({ durum: false });

          })
        } else {// var den= json.Sonuc[0].DosyaAd;

        }
      })
  }
  numuneLegionellaSubmit(event) {
    this.setState({ durum: false });
    this.setState({ eren: null });
    this.setState({ listebilgi: '' });
    var parameters = this.state.kurumVar + '/5';
    var url = this.state.apiUrl + 'numunePdf/kurumgetir/' + parameters;
    fetch(url, {
      method: "GET",
      async: false,
      crossDomain: true,
      xhrFields: {
        withCredentials: false
      },
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ='
      },
    })
      .then((response) => {

        var contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((re) => {
            //this.setState({ eren: re.Sonuc});
            if (re.Sonuc[0].DosyaAd) {
              var newArr = _.sortBy(re.Sonuc, 'Tarih', function (n) {
                return Math.sin(n);
              });


              this.setState({ eren: newArr.reverse() });
              this.setState({ durum: true });
              //var dosyaPath = re.Sonuc[0].DosyaAd;
              //var dosyaRealPath = dosyaPath.replace('ftp://khufu.bestbilgisayar.info//','C:/Raporlar/');
              //var dosyaYol = dosyaRealPath.replace('ftp://93.89.72.167//','C:/Raporlar/');

            } else {
              this.setState({ durum: false });
              this.setState({ listebilgi: 'Sonuç bulunamadı' });
            }


          }).catch(err => {

            this.setState({ durum: false });
          })
        } else {// var den= json.Sonuc[0].DosyaAd;

        }
      })
  }
  numuneDenizSubmit(event) {
    this.setState({ durum: false });
    this.setState({ eren: null });
    this.setState({ listebilgi: '' });
    var parameters = this.state.kurumVar + '/7';
    var url = this.state.apiUrl + 'numunePdf/kurumgetir/' + parameters;
    fetch(url, {
      method: "GET",
      async: false,
      crossDomain: true,
      xhrFields: {
        withCredentials: false
      },
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ='
      },
    })
      .then((response) => {

        var contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((re) => {
            //this.setState({ eren: re.Sonuc});
            if (re.Sonuc[0].DosyaAd) {
              var newArr = _.sortBy(re.Sonuc, 'Tarih', function (n) {
                return Math.sin(n);
              });


              this.setState({ eren: newArr.reverse() });
              this.setState({ durum: true });
              //var dosyaPath = re.Sonuc[0].DosyaAd;
              //var dosyaRealPath = dosyaPath.replace('ftp://khufu.bestbilgisayar.info//','C:/Raporlar/');
              //var dosyaYol = dosyaRealPath.replace('ftp://93.89.72.167//','C:/Raporlar/');

            } else {
              this.setState({ durum: false });
              this.setState({ listebilgi: 'Sonuç bulunamadı' });
            }


          }).catch(err => {

            this.setState({ durum: false });
          })
        } else {// var den= json.Sonuc[0].DosyaAd;

        }
      })
  }
  numuneOrtamSubmit(event) {
    this.setState({ durum: false });
    this.setState({ eren: null });
    this.setState({ listebilgi: '' });
    var parameters = this.state.kurumVar + '/8';
    var url = this.state.apiUrl + 'numunePdf/kurumgetir/' + parameters;
    fetch(url, {
      method: "GET",
      async: false,
      crossDomain: true,
      xhrFields: {
        withCredentials: false
      },
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ='
      },
    })
      .then((response) => {

        var contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((re) => {
            //this.setState({ eren: re.Sonuc});
            if (re.Sonuc[0].DosyaAd) {
              var newArr = _.sortBy(re.Sonuc, 'Tarih', function (n) {
                return Math.sin(n);
              });


              this.setState({ eren: newArr.reverse() });
              this.setState({ durum: true });
              //var dosyaPath = re.Sonuc[0].DosyaAd;
              //var dosyaRealPath = dosyaPath.replace('ftp://khufu.bestbilgisayar.info//','C:/Raporlar/');
              //var dosyaYol = dosyaRealPath.replace('ftp://93.89.72.167//','C:/Raporlar/');

            } else {
              this.setState({ durum: false });
              this.setState({ listebilgi: 'Sonuç bulunamadı' });
            }


          }).catch(err => {

            this.setState({ durum: false });
          })
        } else {// var den= json.Sonuc[0].DosyaAd;

        }
      })
  }
  numuneSwabSubmit(event) {
    this.setState({ durum: false });
    this.setState({ eren: null });
    this.setState({ listebilgi: '' });
    var parameters = this.state.kurumVar + '/7';
    var url = this.state.apiUrl + 'numunePdf/kurumgetir/' + parameters;
    fetch(url, {
      method: "GET",
      async: false,
      crossDomain: true,
      xhrFields: {
        withCredentials: false
      },
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ='
      },
    })
      .then((response) => {

        var contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((re) => {
            //this.setState({ eren: re.Sonuc});
            if (re.Sonuc[0].DosyaAd) {
              var newArr = _.sortBy(re.Sonuc, 'Tarih', function (n) {
                return Math.sin(n);
              });


              this.setState({ eren: newArr.reverse() });
              this.setState({ durum: true });
              //var dosyaPath = re.Sonuc[0].DosyaAd;
              //var dosyaRealPath = dosyaPath.replace('ftp://khufu.bestbilgisayar.info//','C:/Raporlar/');
              //var dosyaYol = dosyaRealPath.replace('ftp://93.89.72.167//','C:/Raporlar/');

            } else {
              this.setState({ durum: false });
              this.setState({ listebilgi: 'Sonuç bulunamadı' });
            }


          }).catch(err => {

            this.setState({ durum: false });
          })
        } else {// var den= json.Sonuc[0].DosyaAd;

        }
      })
  }
  aramaCubugu(e) {
    this.setState({
      arananDosya: e.target.value
    });
  }
  _handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.handleSubmit(event);
    }
  }
  aramaKurumCubugu(e) {
    this.setState({
      aranankurum: e.target.value
    });
  }
  _handleKeyPressKurum = (event) => {
    if (event.key === 'Enter') {
      this.kurumSubmit(event);
    }
  }
  silme(item) {

    var url = this.state.apiUrl + 'numunePdf/sil/' + item.ID;
    fetch(url, {
      method: "DELETE",
      async: false,
      crossDomain: true,
      xhrFields: {
        withCredentials: false
      },
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ='
      }
    })
      .then((response) => {

        var contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((re) => {
            if (re.Gorev[0]) {

            } else {
            }
          }).catch(err => {

          })
        } else {
        }
      })
    const newState = this.state.eren;
    if (newState.indexOf(item) > -1) {
      newState.splice(newState.indexOf(item), 1);
      this.setState({ eren: newState });
    }
  }
  indir(item) {
    var that = this;
    var a = item.DosyaAd;
    var temp = [];
    temp = a.split('/');
    var urll = this.state.apiUrl + 'numunePdf/indir/' + item.ID;
    this.handleToggle()
    axios({
      method: 'get',
      url: urll,
      responseType: 'arraybuffer',
      headers: {
        'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ='
      }
    })
      .then(function (response) {
        that.handleClose()
        filedownload(response.data, temp[6]);
      });
  }
  edit(item) {
    this.setState({ kurumId: item.ID, webusername: item.WebUsername, webpassword: item.WebPassword });


    /*var a = item.DosyaAd;
        var temp = new Array();
        temp = a.split('/');*/
    /*var urll = 'http://iyietki.com/numunePdf/indir/'+item.ID;
    axios({
      method:'get',
      url:urll,
      responseType:'arraybuffer',
       headers: {
      'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ='
    }
    })
      .then(function(response) {

        filedownload(response.data,temp[6]);
    });*/
  }
  kullanici() {
    var url = this.state.apiUrl + 'kurum/ekle/';
    var data = qs.stringify({
      kurumId: this.state.kurumId,
      webusername: this.state.webusername,
      webpassword: this.state.webpassword
    });
    var config = {
      headers: {
        'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ=',
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }
    axios.post(url, data, config

    ).then((response) => {

      this.kurumSubmit();
    }).catch((err) => {

    });
    /* axios({
     method: 'post',
     url: 'http://iyietki.com/kurum/ekle/',
     data: {
       kurumId:"05d6573f-56e6-4e8f-9e15-00219e42e570",
       webusername: 'react',
       webpassword: 'dan gelen'
     },
     crossDomain: true,
     headers: {
       'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ=',
       'Content-type': 'application/x-www-form-urlencoded'
     }
   });*/
  }

  render() {

    function Greeting(props) {
      const isLoggedIn = props.isLoggedIn;
      const liste = props.liste;

      if (isLoggedIn) {
        return <Raporlar numbers={liste} sil={props.silme} indir={props.indir} yetki={props.yetki} oturum={props.oturum} />;
      } else {
        return <div className="listebilgi">{props.listebilgi}</div>
      }
      //return null;
    }
    function Kuruming(props) {
      const isLoggedIn = props.isLoggedIn;
      const liste = props.liste;

      if (isLoggedIn) {
        return <Kurumlar sayilar={liste} editter={props.edit} />;
      } else {
        return <div>{props.listebilgi}</div>
      }
      //return null;
    }
    return (
      <Router>
        <S.Wrapper>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={this.state.open}
            onClick={() => this.handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <S.Wrapall>
            {this.state.authontication && <Nav permission={this.state.permission} authontication={this.state.authontication} cikis={this.cikis} />}

            <S.Content>
              <Route exact path="/" render={() => (<Login
                panel={this.state.panel}
                handleChangeUser={this.handleChangeUser}
                handleChangePass={this.handleChangePass}
                handleLogin={this.handleLogin}
                logindurum={this.state.logindurum}
                girisMetni={this.state.girisMetni}
              />)}
              />

              <Route path="/rapor" render={() => (<S.FullHeight>
                {this.state.authontication & !this.state.permission ? <>
                  <S.SolPanel>
                    <ul>
                      <li><div className="cubuk"></div><img src={require('./img/restaurant.png')} alt="" /><input className="buttonum" type="submit" value="Gıda" onClick={this.numuneGidaSubmit} /></li>
                      <li><div className="cubuk"></div><img src={require('./img/sea.png')} alt="" /><input className="buttonum" type="submit" value="Havuz Suyu Özel" onClick={this.numuneHavuzSuSubmit} /></li>
                      <li><div className="cubuk"></div><img src={require('./img/swimming-pool.png')} alt="" /><input className="buttonum" type="submit" value="Havuz Suyu" onClick={this.numuneHavuzSuyuSubmit} /></li>
                      <li><div className="cubuk"></div><img src={require('./img/bug-shield.png')} alt="" /><input className="buttonum" type="submit" value="Legionella" onClick={this.numuneLegionellaSubmit} /></li>
                      <li><div className="cubuk"></div><img src={require('./img/test-tube-and-flask-for-chemistry-class.png')} alt="" /><input className="buttonum" type="submit" value="Kimyasal" onClick={this.numuneKimyasalSubmit} /></li>
                      <li><div className="cubuk"></div><img src={require('./img/drop.png')} alt="" /><input className="buttonum" type="submit" value="Su Özel" onClick={this.numuneSuSubmit} /></li>
                      <li><div className="cubuk"></div><img src={require('./img/ortam.png')} alt="" /><input className="buttonum" type="submit" value="Swab" onClick={this.numuneSwabSubmit} /></li>
                      <li><div className="cubuk"></div><img src={require('./img/swimming-pool.png')} alt="" /><input className="buttonum" type="submit" value="Deniz Suyu" onClick={this.numuneDenizSuyuSubmit} /></li>
                      <li><div className="cubuk"></div><img src={require('./img/ortam.png')} alt="" /><input className="buttonum" type="submit" value="Ortam" onClick={this.numuneOrtamSubmit} /></li>
                      <li><div className="cubuk"></div><img src={require('./img/ortam.png')} alt="" /><input className="buttonum" type="submit" value="Mantar" onClick={this.numuneMantarSubmit} /></li>
                      {/*<li><div className="cubuk"></div><img src={require('./img/deniz.png')} alt=""/><input className="buttonum" type="submit" value="Deniz" onClick={this.numuneDenizSubmit} /></li>*/}
                    </ul>
                  </S.SolPanel>
                  <S.ContentList>
                    <Greeting
                      isLoggedIn={this.state.durum}
                      liste={this.state.eren}
                      silme={this.silme}
                      indir={this.indir}
                      yetki={this.state.permission}
                      listebilgi={this.state.listebilgi}
                    />
                  </S.ContentList>
                  </>: <div>{this.state.girisMetni}</div>}
              </S.FullHeight>)}
              />
              <Route path="/istatistik" render={() => (<S.FullHeight>
                {this.state.authontication & !this.state.permission ? <>
                  <Istatistik kuruminfo={this.state.kurumInfo} />
                </> : <div>{this.state.girisMetni}</div>}
              </S.FullHeight>)}
              />

              <Route path="/yonetim" render={() => (
                this.state.permission ? <S.RaporSilPanel>
                  <div className="raporarama">
                    <img src={SearchImg} alt="" />
                    <input placeholder="Aranacak rapor adı yada kurumu yazıp 'ENTER' a basın..." type="text" onChange={this.aramaCubugu} onKeyPress={this._handleKeyPress} />
                  </div>
                  <div className="contentlist">
                    <Greeting
                      isLoggedIn={this.state.durum}
                      liste={this.state.eren}
                      silme={this.silme}
                      indir={this.indir}
                      yetki={this.state.permission}
                    />
                  </div>
                </S.RaporSilPanel> : <div>{this.state.girisMetni}</div>
              )}
              />

              <Route path="/kurumekle" render={() => (
                this.state.permission ? <S.RaporSilPanel>
                  <div className="raporarama">
                    <img src={SearchImg} alt="" />
                    <input placeholder="Aranacak kurum kodunu yazıp 'ENTER' a basın..." type="text" onChange={this.aramaKurumCubugu} onKeyPress={this._handleKeyPressKurum} />
                  </div>
                  <div className="kurumedit">
                    <input placeholder="Web Username" value={this.state.webusername == null ? 'Deger belirtilmemiş' : this.state.webusername} type="text" onChange={this.webuserCubugu} />
                    <input placeholder="Web Password" value={this.state.webpassword == null ? 'Deger belirtilmemiş' : this.state.webpassword} type="text" onChange={this.webpassCubugu} />
                    <input type="submit" value="Kurum Kaydet" onClick={this.kullanici} />
                  </div>

                  <div className="contentlistkurum">
                    <Kuruming
                      isLoggedIn={this.state.durum}
                      liste={this.state.kurumarray}
                      edit={this.edit}
                      listebilgi={this.state.listebilgi}
                    /></div></S.RaporSilPanel> : <div>{this.state.girisMetni}</div>
              )}
              />
            </S.Content>
          </S.Wrapall>

        </S.Wrapper>

      </Router>
    );
  }
}

export default App;
